export default __webpack_public_path__ + "static/media/checkout_gold.50caaa22.svg";